import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, ArrowDownCircle, ArrowUpCircle, RotateCcw } from 'lucide-react';

const typeConfig = {
  credit: {
    icon: ArrowUpCircle,
    color: 'text-red-600 dark:text-red-400',
    bg: 'bg-red-50 dark:bg-red-900/20',
    label: 'Credit Given',
  },
  payment: {
    icon: ArrowDownCircle,
    color: 'text-emerald-600 dark:text-emerald-400',
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
    label: 'Payment Received',
  },
  adjustment: {
    icon: RotateCcw,
    color: 'text-amber-600 dark:text-amber-400',
    bg: 'bg-amber-50 dark:bg-amber-900/20',
    label: 'Adjustment',
  },
};

export default function CustomerTransactionRow({ transaction, index }) {
  const type = transaction.type || 'credit';
  const config = typeConfig[type] || typeConfig.credit;
  const Icon = config.icon;
  const isCredit = type === 'credit';

  return (
    <motion.div
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.03, duration: 0.2 }}
      className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors"
    >
      <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${config.bg}`}>
        <Icon size={16} className={config.color} />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-900 dark:text-white">
            {transaction.description || config.label}
          </span>
        </div>
        <p className="text-xs text-gray-400 dark:text-gray-500">
          {transaction.date
            ? new Date(transaction.date).toLocaleDateString('en-PK', {
                day: '2-digit', month: 'short', year: 'numeric',
                hour: '2-digit', minute: '2-digit',
              })
            : ''}
        </p>
      </div>

      <div className="text-right flex-shrink-0">
        <p className={`text-sm font-bold ${isCredit ? 'text-red-600 dark:text-red-400' : 'text-emerald-600 dark:text-emerald-400'}`}>
          {isCredit ? '+' : '-'}Rs. {Math.abs(transaction.amount || 0).toLocaleString()}
        </p>
      </div>

      <div className="text-right w-24 flex-shrink-0">
        <p className="text-sm font-semibold text-gray-900 dark:text-white">
          Rs. {(transaction.balanceAfter || 0).toLocaleString()}
        </p>
        <p className="text-[10px] text-gray-400 dark:text-gray-500">Balance</p>
      </div>
    </motion.div>
  );
}
